import React from "react"
import Navbar from "../../../Common/Navbar"
import Footer from "../../../Common/Footer"
import Sidebar from "../../../Sidebar/Sidebar"
import SlotsTableComp from "./Component/SlotsTableComp"


const SlotsTable =()=>{
    return(
        <>
        <Navbar />
        <div className="d-flex mainContentArea">
            <Sidebar />
            <SlotsTableComp />
        </div>
        <Footer />
        </>
    )
}

export default SlotsTable;